<template>
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_1999_66656)">
			<path 
				d="M7.33337 4.66683H8.66671V6.00016H7.33337V4.66683ZM7.33337 7.3335H8.66671V11.3335H7.33337V7.3335ZM8.00004 1.3335C4.32004 1.3335 1.33337 4.32016 1.33337 8.00016C1.33337 11.6802 4.32004 14.6668 8.00004 14.6668C11.68 14.6668 14.6667 11.6802 14.6667 8.00016C14.6667 4.32016 11.68 1.3335 8.00004 1.3335ZM8.00004 13.3335C5.06004 13.3335 2.66671 10.9402 2.66671 8.00016C2.66671 5.06016 5.06004 2.66683 8.00004 2.66683C10.94 2.66683 13.3334 5.06016 13.3334 8.00016C13.3334 10.9402 10.94 13.3335 8.00004 13.3335Z"
				:fill="color"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1999_66656">
				<rect
					width="16"
					height="16"
					fill="white"
				/>
			</clipPath>
		</defs>
	</svg>
</template>

<script setup>
import { toRefs } from 'vue';

const props = defineProps({
	color: {
		type:String,
		default: '#2A8176'
	}
});

const { color } = toRefs(props);

</script>